import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../services/auth.service';
import { JwtHelperService } from '../services/jwt-helper.service';

/**
 * Auth guard - checks if user has valid token
 * Shows toastr message if not authorized
 */
export const authGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const jwtHelper = inject(JwtHelperService);
  const toastr = inject(ToastrService);
  const translate = inject(TranslateService);

  const token = authService.getToken();

  // Check if token exists
  if (!token) {
    toastr.warning(
      translate.instant('toastr.messages.pleaseLogin'),
      translate.instant('toastr.titles.authRequired'),
      { timeOut: 4000, positionClass: 'toast-top-right' }
    );
    authService.setRedirectUrl(state.url);
    router.navigate(['/auth/login']);
    return false;
  }

  // Check if token is expired
  if (jwtHelper.isTokenExpired(token)) {
    toastr.warning(
      translate.instant('toastr.messages.sessionExpiredLogin'),
      translate.instant('toastr.titles.sessionExpired'),
      { timeOut: 4000, positionClass: 'toast-top-right' }
    );
    authService.logout();
    authService.setRedirectUrl(state.url);
    router.navigate(['/auth/login']);
    return false;
  }

  return true;
};
